import { ChevronDown } from "lucide-react";
import SearchableSelect from "modules/swiftboard/components/ui/SearchableSelect";

/**
 * Surface picker cell. Renders a light button until clicked/activated, then
 * swaps in SearchableSelect (open + focused) — keeps 68 rows cheap.
 */
export default function SurfaceCell({ line, surfaceId, surfaceName, options, editing, onEdit, onPick, onClose }) {
  if (editing) {
    return (
      <div className="w-[270px]">
        <SearchableSelect
          compact
          autoFocus
          defaultMenuIsOpen
          options={options}
          value={surfaceId || ""}
          onChange={(v) => {
            if (v) onPick(v);
            onClose();
          }}
          onMenuClose={onClose}
          placeholder="Search surfaces…"
          ariaLabel={`Surface for ${line.rawName}`}
        />
      </div>
    );
  }

  return (
    <button
      type="button"
      onMouseDown={(e) => e.preventDefault()}
      onClick={onEdit}
      aria-label={`Change surface for ${line.rawName}${surfaceName ? `, currently ${surfaceName}` : ""}`}
      className={`flex h-7 w-[270px] items-center justify-between gap-2 rounded-[4px] border px-2 text-left text-[12.5px] focus:outline-none focus-visible:ring-2 focus-visible:ring-border_strong ${
        surfaceId ? "border-border bg-surface text-text_primary" : "border-danger_border bg-danger_bg text-danger"
      }`}
    >
      <span className="truncate">{surfaceName || "Select surface…"}</span>
      <ChevronDown size={13} className="flex-shrink-0 text-text_muted" aria-hidden="true" />
    </button>
  );
}
